import React from "react";
import {motion} from "framer-motion";

export default function DetailSponsor(){
    return(
        <div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto mt-8 mb-16">
            <div className="grid grid-cols-1 gap-x-12 gap-y-16 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3">
                <a
                    href="https://www.vinnova.se/en/"
                    target="_blank"
                    className="text-center"
                    rel="noopener noreferrer"
                >
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, y: 50 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.4}}
                        viewport={{once: false}}
                    >
                        <img className="w-auto h-32 object-contain mx-auto text-gray-800 max-w-[14rem]"
                             src="https://static.igem.wiki/teams/5122/homepage/logo-vinnova-2.png" alt="description"/>
                    </motion.div>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Vinnova
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            Sponsor with a project grant
                        </p>
                    </div>
                </a>
                <a
                    href="https://www.kth.se/en"
                    target="_blank"
                    className="text-center"
                    rel="noopener noreferrer"
                >
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, y: 50 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.6}}
                        viewport={{once: false}}
                    >
                        <img className="w-auto h-32 mx-auto text-gray-800 rounded-lg"
                             src="https://static.igem.wiki/teams/5122/homepage/logo-kth.png" alt="description"/>
                    </motion.div>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            KTH Royal Institute of Technology
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            Sponsor with a project grant
                        </p>
                    </div>
                </a>
                <a
                    href="https://ki.se/en"
                    target="_blank"
                    className="text-center"
                    rel="noopener noreferrer"
                >
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, y: 50 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <img className="w-auto h-32 mx-auto text-gray-800 rounded-lg"
                             src="https://static.igem.wiki/teams/5122/homepage/logo-ki.png" alt="description"/>
                    </motion.div>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Karolinska Institutet
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            Sponsor with two project grants
                        </p>
                    </div>
                </a>
                <a
                    href="https://eu.idtdna.com/page"
                    target="_blank"
                    className="text-center"
                    rel="noopener noreferrer"
                >
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, y: 50 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.5}}
                        viewport={{once: false}}
                    >
                        <img className="w-auto h-32 mx-auto object-contain text-gray-800 max-w-[14rem]"
                             src="https://static.igem.wiki/teams/5122/homepage/logo-idt-2.png" alt="description"/>
                    </motion.div>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Integrated DNA Technologies
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            Sponsor with DNA oligo free of charge
                        </p>
                    </div>
                </a>
                <a
                    href="https://www.microsynth.com/home-ch.html"
                    target="_blank"
                    className="text-center"
                    rel="noopener noreferrer"
                >
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, y: 50 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.7}}
                        viewport={{once: false}}
                    >
                        <img className="w-auto h-32 mx-auto object-contain text-gray-800 max-w-[14rem]"
                             src="https://static.igem.wiki/teams/5122/homepage/logo-microsynth-2.png" alt="description"/>
                    </motion.div>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            Microsynth
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            Sponsor with sequencing free of charge
                        </p>
                    </div>
                </a>
                <a
                    href="https://biogdp.com/"
                    target="_blank"
                    className="text-center"
                    rel="noopener noreferrer"
                >
                    <motion.div
                        variants={{
                            hidden: { opacity: 0, y: 50 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.9}}
                        viewport={{once: false}}
                    >
                        <img className="w-auto h-32 mx-auto object-contain text-gray-800 max-w-[10rem]"
                             src="https://static.igem.wiki/teams/5122/homepage/logo-gdp-2.png" alt="description"/>
                    </motion.div>
                    <div className="mt-2 sm:mt-6">
                        <p className="text-xl font-bold text-orange-500">
                            BioGDP
                        </p>
                        <p className="text-lg mt-2 sm:mt-4 text-gray-500">
                            Sponsor with free biomedical graphics
                        </p>
                    </div>
                </a>
            </div>
        </div>
    )
}